import * as React from 'react';
import PropTypes from 'prop-types';

import SvgIcon from '@mui/material/SvgIcon';

const CircularEditIcon = ({ width = 39, height = 41 }) => (
  <SvgIcon
    width={width}
    height={height}
    viewBox="0 0 39 41"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width={width} height={height} rx="19.5" fill="#1DA83B" />
    <path
      d="M10.4988 25.7513V29.5013H14.2488L25.3088 18.4413L21.5588 14.6913L10.4988 25.7513ZM28.2088 15.5413C28.5988 15.1513 28.5988 14.5213 28.2088 14.1313L25.8688 11.7913C25.4788 11.4013 24.8488 11.4013 24.4588 11.7913L22.6288 13.6213L26.3788 17.3713L28.2088 15.5413Z"
      fill="white"
    />
  </SvgIcon>
);

CircularEditIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};

export default CircularEditIcon;
